/* IBO custom (see theme/CUSTOMIZATIONS.md), 2026-09-29. Product-card quick add pill (reports/design/2026-09-29-instacart-mobile-spec.md §2).
   Loaded on every page by sections/ibo-free-shipping-bar.liquid, defer.
   1. Trash at 1: Canopy's card stepper (snippets/product-card.liquid, .ibo-qa) shows "− 1 +" after the first add. At quantity 1
      the minus removes the line, so it gets the class .ibo-q1 and ibo.css draws a trash icon instead of the minus.
   2. QA 2026-09-29 (stale pill after a remove, also on the old theme): after every cart change each card pill is re-synced
      from /cart.js (quantity, data-initial-value, data-index = line, shown/hidden). A pill "+" or "−" for a variant that is
      not in the cart any more does not call /cart/change (Shopify answers "no valid id or line parameter"): "+" submits the
      card form as a normal add instead, "−" just re-syncs.
   3. Raw Shopify errors never show on a card: the card's alert text is replaced by a friendly retry message
      (data-ibo-err, locale ibo.card.error), the pill is re-synced and the message hides after 5 s. */
(() => {
  const d = document;
  const SEL = '.ibo-qa quantity-input';
  const nativeFetch = window.fetch.bind(window);
  let inCart = null; // Map variantId -> { qty, index } from the last /cart.js read

  // Trash state + the card's own button state. QA 2026-09-29: cards inside the product page's .product-info ("Items to add
  // next") get Canopy's main-form rules (minus disabled at load because 0 <= min 0 and never re-enabled; the main product's
  // stock limit as max), so the card's limit (data-ibo-max) is restored and the buttons are recomputed from its own value.
  const setQ1 = (qi) => {
    const input = qi.querySelector('.qty-input__input');
    if (!input) return;
    const q = parseInt(input.value, 10) || 0;
    qi.classList.toggle('ibo-q1', q <= 1);
    if ('iboMax' in input.dataset) {
      if (input.dataset.iboMax) input.max = input.dataset.iboMax; else input.removeAttribute('max');
    }
    const max = Number(input.max) || 0;
    const minus = qi.querySelector('.btn--minus');
    const plus = qi.querySelector('.btn--plus');
    if (minus) minus.disabled = q < 1;
    if (plus) plus.disabled = max > 0 && q >= max;
  };
  const allQ1 = (root) => (root || d).querySelectorAll(SEL).forEach(setQ1);

  // ---- 2. re-sync every card pill with the cart ----
  const apply = () => {
    if (!inCart) return;
    d.querySelectorAll('.ibo-qa product-form[data-variant-id]').forEach((pf) => {
      const qi = pf.querySelector('quantity-input');
      const input = qi && qi.querySelector('.qty-input__input');
      if (!input || qi.getAttribute('aria-disabled') === 'true') return; // a change is in flight
      const line = inCart.get(String(pf.dataset.variantId));
      const qty = line ? line.qty : 0;
      input.value = qty;
      input.dataset.initialValue = qty;
      if (line) input.dataset.index = line.index; else input.removeAttribute('data-index');
      qi.currentQty = String(qty);
      const shown = qty > 0 ? 'true' : 'false';
      if (pf.dataset.showQuantitySelector !== shown) pf.setAttribute('data-show-quantity-selector', shown);
      setQ1(qi);
    });
  };
  let syncT;
  const resync = (delay = 250) => {
    clearTimeout(syncT);
    syncT = setTimeout(() => {
      nativeFetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const m = new Map();
          cart.items.forEach((it, i) => {
            if (it.properties && it.properties._ibo_gift) return; // task 238: the free gift line is not the card's product line
            const k = String(it.variant_id);
            const prev = m.get(k);
            m.set(k, { qty: (prev ? prev.qty : 0) + it.quantity, index: prev ? prev.index : i + 1 });
          });
          inCart = m;
          apply();
        })
        .catch(() => {});
    }, delay);
  };

  window.fetch = function iboCardsFetch(input) {
    const p = nativeFetch.apply(this, arguments);
    try {
      const u = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(() => resync(), () => resync());
    } catch (e) { /* ignore */ }
    return p;
  };
  ['on:cart:add', 'on:line-item:change', 'on:cart:error', 'on:cart-drawer:after-open'].forEach((ev) => d.addEventListener(ev, () => resync()));
  d.addEventListener('on:variant:change', () => setTimeout(() => allQ1(), 0)); // Canopy re-applies the main form's limits then
  window.addEventListener('pageshow', (e) => { if (e.persisted) resync(0); });

  // pill buttons for a variant that is not in the cart: add instead of /cart/change
  d.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest(`${SEL} .qty-input__btn`);
    if (!btn || !inCart) return;
    const pf = btn.closest('product-form');
    if (!pf || inCart.has(String(pf.dataset.variantId))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.name === 'plus') {
      const form = pf.querySelector('form');
      const add = pf.querySelector('.btn--atc');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(add || undefined);
    } else {
      resync(0);
    }
  }, true);

  // ---- 1. trash state ----
  d.addEventListener('change', (e) => {
    const qi = e.target.closest && e.target.closest(SEL);
    if (qi) setQ1(qi);
  }, true);
  d.addEventListener('click', (e) => {
    const qi = e.target.closest && e.target.closest(SEL);
    if (qi) setTimeout(() => setQ1(qi), 0);
  });

  // ---- 3. friendly card errors ----
  const friendly = (alert) => {
    const box = alert.closest('.ibo-qa');
    const msg = box && box.dataset.iboErr;
    if (!msg || alert.hidden || !alert.textContent.trim() || alert.textContent === msg) return;
    alert.textContent = msg;
    resync(0);
    clearTimeout(alert.iboT);
    alert.iboT = setTimeout(() => { alert.hidden = true; alert.textContent = ''; }, 5000);
  };

  const start = () => {
    allQ1();
    if (d.querySelector('.ibo-qa product-form')) resync(0);
    new MutationObserver((muts) => {
      for (const m of muts) {
        const t = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        if (!t) continue;
        const alert = t.closest && t.closest('.ibo-qa .alert');
        if (alert) { friendly(alert); continue; }
        if (m.type === 'attributes' && m.attributeName === 'data-show-quantity-selector') {
          const qi = t.querySelector && t.querySelector('quantity-input');
          if (qi && t.closest('.ibo-qa')) setQ1(qi);
        } else if (m.type === 'childList') {
          for (const n of m.addedNodes) {
            if (n.nodeType === 1 && (n.matches(SEL) || n.querySelector('.ibo-qa'))) { allQ1(n.matches(SEL) ? n.parentNode : n); if (inCart) apply(); else resync(); }
          }
        }
      }
    }).observe(d.body, { attributes: true, attributeFilter: ['data-show-quantity-selector', 'hidden'], childList: true, characterData: true, subtree: true });
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
